import _ from "underscore";
import domready from 'domready';
domready(function () {
  var configuration = document.getElementById("booking-departure-configuration");
  if (!configuration) {
    return;
  }
  var personDetails = Array.from(document.querySelectorAll("#booking-persons-details [data-person-details]"));
  var personCount = document.getElementById("person-count");
  function render() {
    var currentPersons = parseInt(personCount.value);
    personDetails.forEach(function (element, index) {
      var inputs = Array.from(element.querySelectorAll("input, select"));
      if (index < currentPersons) {
        element.style.display = "";
        inputs.forEach(function (input) {
          input.removeAttribute("disabled");
          var $parent = input.closest("fieldset > dl");
          if ($parent && $parent.classList.contains("booking-form__field--mandatory")) {
            input.setAttribute("required", true);
          }
        });
      } else {
        element.style.display = "none";
        inputs.forEach(function (input) {
          input.setAttribute("disabled", true);
          input.removeAttribute("required");
          input.value = "";
        });
      }
    });
  }
  render();
  configuration.addEventListener("personCountChanged", render);
});
